// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.valuetool-body > div.ButtonBar {
    margin-bottom: 0.25em;
}

table.valuetool-table,
table.valuetool-table-selection {
    background-color: var(--list-bg-color);
    width: 100%;
    border: 1px solid var(--border-color);
}

table.valuetool-table tr:nth-child(odd),
table.valuetool-table-selection tr:nth-child(odd) {
    background-color: #F0F0F0;
}

table.valuetool-table th,
table.valuetool-table-selection th {
    background-color: var(--list-section-bg-color);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 2px;
}

table.valuetool-table td:first-child,
table.valuetool-table-selection td:first-child {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 2px;
    padding-left: 0.25em;
}

table.valuetool-table td:nth-child(2) {
    text-align: right;
    max-width: 1px;
    padding-right: 0.25em;
}

table.valuetool-table-selection td span.icon {
    margin-right: 0.5em;
}

table.valuetool-table-selection td:nth-child(2) {
    max-width: 2px;
}

table.valuetool-table-selection td:nth-child(2) > div.TextInput {
    width: 100%;
}


table.valuetool-table-options {
    width: 100%;
}

table.valuetool-table-options td > select {
    width: 100%;
}

table.valuetool-table-options td:first-child {
    white-space: nowrap;
}

div.valuetool-chart-options {
    display: flex;
    align-items: center;
}

div.valuetool-chart-options > div.number-input {
    flex: 1 1 auto;
    margin-left: 0.25em;
}`, "",{"version":3,"sources":["webpack://./plugins/style/ValueTool.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,sCAAsC;IACtC,WAAW;IACX,qCAAqC;AACzC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB","sourcesContent":["div.valuetool-body > div.ButtonBar {\n    margin-bottom: 0.25em;\n}\n\ntable.valuetool-table,\ntable.valuetool-table-selection {\n    background-color: var(--list-bg-color);\n    width: 100%;\n    border: 1px solid var(--border-color);\n}\n\ntable.valuetool-table tr:nth-child(odd),\ntable.valuetool-table-selection tr:nth-child(odd) {\n    background-color: #F0F0F0;\n}\n\ntable.valuetool-table th,\ntable.valuetool-table-selection th {\n    background-color: var(--list-section-bg-color);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 2px;\n}\n\ntable.valuetool-table td:first-child,\ntable.valuetool-table-selection td:first-child {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 2px;\n    padding-left: 0.25em;\n}\n\ntable.valuetool-table td:nth-child(2) {\n    text-align: right;\n    max-width: 1px;\n    padding-right: 0.25em;\n}\n\ntable.valuetool-table-selection td span.icon {\n    margin-right: 0.5em;\n}\n\ntable.valuetool-table-selection td:nth-child(2) {\n    max-width: 2px;\n}\n\ntable.valuetool-table-selection td:nth-child(2) > div.TextInput {\n    width: 100%;\n}\n\n\ntable.valuetool-table-options {\n    width: 100%;\n}\n\ntable.valuetool-table-options td > select {\n    width: 100%;\n}\n\ntable.valuetool-table-options td:first-child {\n    white-space: nowrap;\n}\n\ndiv.valuetool-chart-options {\n    display: flex;\n    align-items: center;\n}\n\ndiv.valuetool-chart-options > div.number-input {\n    flex: 1 1 auto;\n    margin-left: 0.25em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
